module.exports = __webpack_public_path__ + "img/Cisco_8841.595fadf3.png";